import TransferPartsModal from './TransferPartsModal'

import { ActionModalType } from 'components/ActionModal'
import { heapEvent } from '@equipmentshare/heaper'

export function getTransferPartsModal(): ActionModalType {
	return {
		component: TransferPartsModal,
		label: 'Transfer Items',
		width: 700,
		onXClick: () => heapEvent( 'Inventory - Transfer Parts Modal - Click - X button', {} ),
	}
}
